import { Grid, Text } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { UserSettingsContainer } from "../../../../../pages/Settings/AccountDetails/AccountDetails.styled";
import { useGetApi } from "../../../../../hooks";
import { getYachtId } from "../../../../../utils";
import { useFormContext } from "react-hook-form";
import { Flex, StyledTable, StyledTh, StyledTr } from "../../../../../styled";
import { specMapper } from "../NMEA.utils";
import NMEAMappingItem from "./NMEAMappingItem";
import { useState } from "react";
import type { ComboboxItem } from "@mantine/core";

interface Props {
  logbooks: ComboboxItem[];
  watch: (name: string) => any;
  disabled: boolean | undefined;
}

const NMEAMapping = ({ logbooks, watch, disabled }: Props) => {
  const { register, setValue } = useFormContext();
  const [selectedLogbook, setSelectedLogbook] = useState<string | null>(null);

  const { data, refetch } = useGetApi({
    request: "get-nmea-logbook-spec",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
    mapper: specMapper,
  });

  const handleLogbookChange = async (value: string | null) => {
    setSelectedLogbook(value);
    const data = await refetch({
      params: {
        lbid: value,
      },
    });
    setValue(`list.${value}`, data.list ?? []);
  };
  return (
    <Grid.Col span={1}>
      <UserSettingsContainer
        style={{
          flexDirection: "column",
          padding: 20,
          ...(disabled && { opacity: 0.5, pointerEvents: "none" }),
        }}>
        <Text mb={15}>Mapping</Text>
        <Flex gap={10} direction="column">
          <Select
            value={selectedLogbook}
            label="Logbook"
            onChange={handleLogbookChange}
            data={logbooks}
            maw={300}
          />
          {!data ? (
            <Text ta="center">
              {disabled
                ? "You must first save your credentials to edit mapping"
                : "You must first select logbook to edit mapping"}
            </Text>
          ) : (
            <div style={{ overflowY: "scroll", height: 600 }}>
              <StyledTable>
                <StyledTr>
                  <StyledTh>Column Name</StyledTh>
                  <StyledTh>Mapped ID</StyledTh>
                </StyledTr>
                {data.list.map((item, index) => (
                  <NMEAMappingItem
                    key={`mapping-${index}`}
                    index={index}
                    watch={watch}
                    lbid={selectedLogbook}
                    availableMappings={data.availableMappings}
                    {...item}
                  />
                ))}
              </StyledTable>
            </div>
          )}
        </Flex>
      </UserSettingsContainer>
    </Grid.Col>
  );
};
export default NMEAMapping;